import { render, staticRenderFns } from "./DeliverForm.vue?vue&type=template&id=6f3ccbb8"
import script from "./DeliverForm.vue?vue&type=script&lang=js"
export * from "./DeliverForm.vue?vue&type=script&lang=js"
import style0 from "./DeliverForm.vue?vue&type=style&index=0&id=6f3ccbb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports